import {
	gsap
} from 'gsap'

export const app = () => {
	const wishList = document.querySelector('.wishlist-icon')

	function tracking(param) {
		console.log(param);
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(param);
	}

	function scrollToTop() {
		// For modern browsers
		if (window.scrollTo) {
			window.scrollTo({
				top: 0,
				behavior: "smooth" // Optional: Add smooth scrolling behavior
			});
		}
		// For older browsers that don't support smooth scrolling
		else if (document.documentElement.scrollTop) {
			document.documentElement.scrollTop = 0;
		} else {
			// Fallback for very old browsers
			document.body.scrollTop = 0;
		}
	}

	async function fetch_result(endpoint, body = null) {
		try {
			let baseURL = window.location.origin + "/";
			if (window.location.href.includes('volantino-digitale')) {
				baseURL = baseURL + 'volantino-digitale/';
			} else if (window.location.href.includes('volantino')) {
				baseURL = baseURL + 'volantino/';
			}
			const response = await fetch(baseURL + 'frontend-api/v1/' + endpoint, {
				method: 'POST',
				body: JSON.stringify(body)
			});
			return response.json();
		} catch (error) {
			throw new Error(`fetch request error: ${error.status}`);
		}
	}

	function parseQueryParams(queryString) {
		const queryParams = {};
		const searchParams = new URLSearchParams(queryString);

		for (const [key, value] of searchParams.entries()) {
			queryParams[key] = value;
		}

		return queryParams;
	}

	function setCookie(name, value, daysToExpire) {
		const date = new Date();
		date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
		const expires = "expires=" + date.toUTCString();
		document.cookie = name + "=" + value + ";" + expires + ";path=/";
	}

	function checkCookie(name) {
		// Split the cookies into an array
		const cookies = document.cookie.split(';');

		// Iterate through the cookies and look for the one with the specified name
		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i].trim();

			// Check if the cookie starts with the specified name
			if (cookie.indexOf(name + '=') === 0) {
				return true;
			}
		}

		// If the cookie with the specified name was not found
		return false;
	}

	//FILTRI NEGOZI
	const negoziScheda = document.querySelectorAll('.negozio-scheda')
	const citySelect = document.getElementById("citySelect");
	const provinciaSelect = document.getElementById("provinciaSelect");
	if (provinciaSelect) {
		provinciaSelect.addEventListener("change", function() {
			var selectedValue = this.value;
			citySelect.selectedIndex = 0;
			negoziScheda.forEach(negozio => {
				if (negozio.getAttribute("data-provincia") == selectedValue) {
					negozio.classList.remove('hidden')
				} else {
					negozio.classList.add('hidden')
				}
			});
			for (var i = 1; i < citySelect.options.length; i++) {
				var option = citySelect.options[i];
				if (option.getAttribute('data-provincia') != selectedValue) {
					option.style.display = "none";
				} else {
					option.style.display = "block";
				}
			}
		});
	}
	if (citySelect) {
		citySelect.addEventListener("change", function() {
			var selectedValue = this.value;
			negoziScheda.forEach(negozio => {
				if (negozio.getAttribute("data-citta") == selectedValue) {
					negozio.classList.remove('hidden')
				} else {
					negozio.classList.add('hidden')
				}
			});
		});
	}



	document.getElementById('hider').addEventListener('click', function() {
		document.querySelector('html').classList.remove('show-filters', 'show-cerca')
		gsap.to('div#hider', {
			opacity: 0,
			pointerEvents: 'none',
			ease: "easeIn",
		});
	});
	//FILTRI
	const productList = document.querySelectorAll('.prodotto');
	const buttonFilters = document.querySelectorAll('.button--filtri');

	buttonFilters.forEach(button => {
		var idButton = button.getAttribute('data-id')
		var prodotti = document.querySelectorAll('.prodotto[data-cat*="' + idButton + '"]')
		if (!prodotti.length) {
			button.remove()
		}
	})

	document.getElementById('filtri').addEventListener('click', function() {
		document.querySelector('html').classList.toggle('show-filters')
		if (document.querySelector('html').classList.contains('show-filters')) {
			gsap.to('div#hider', {
				opacity: 1,
				pointerEvents: 'all',
				ease: "easeIn",
			});
		} else {
			gsap.to('div#hider', {
				opacity: 0,
				pointerEvents: 'none',
				ease: "easeIn",
			});
		}

		document.querySelector('html').classList.remove('show-locator')
		gsap.to('#locator', {
			y: '100%',
			duration: 0.1,
			ease: "easeIn",
		});
		document.querySelector('html').classList.remove('show-panel')
		gsap.to('#scheda', {
			y: '100%',
			duration: 0.1,
			ease: "easeIn",
		});
	});
	const filtroselezionato = document.getElementById('filtro-selezionato')
	if (filtroselezionato) {


		filtroselezionato.addEventListener('click', function() {
			productList.forEach(product => {
				product.classList.remove('hidden')
			});
			document.getElementById('filtro-selezionato').classList.add('hidden')
			//document.querySelector('html').classList.toggle('show-filters')
			//gsap.to('div#hider', {
			//	opacity: 1,
			//	pointerEvents: 'all',
			//	ease: "easeIn",
			//});
			//
			//document.querySelector('html').classList.remove('show-locator')
			//gsap.to('#locator', {
			//	y: '100%',
			//	duration: 0.1,
			//	ease: "easeIn",
			//});
			//document.querySelector('html').classList.remove('show-panel')
			//gsap.to('#scheda', {
			//	y: '100%',
			//	duration: 0.1,
			//	ease: "easeIn",
			//});
		});
	}

	const negoziSchedaLink = document.querySelectorAll('.negozio-scheda a.market-link')
	negoziSchedaLink.forEach(button => {
		button.addEventListener('click', function(element) {
			tracking({
				'event': 'market_click',
				'event_category' : 'market_click',
				'event_name': 'click',
				'event_label': button.parentNode.querySelector('.store-info-title').innerText
			});
		});
	});

	const negoziSchedaLink_change = document.querySelectorAll('.change_market a.market-link')
	negoziSchedaLink_change.forEach(button => {
		button.addEventListener('click', function(event) {
			tracking({
				'event': 'change_market_click',
				'event_name': 'click',
				'event_category' : 'change_market_click',
				'event_label': button.parentNode.querySelector('.store-info-title').innerText
			});
		});
	});

	const outbound_click = document.querySelectorAll('a[target="_blank"]');
	outbound_click.forEach(button => {
		button.addEventListener('click', function(element) {
			tracking({
				'event': 'outbound_click',
				'event_name': 'click',
				'outbound': true,
				'event_category': 'outbound',
				'event_label': button.innerText,
				'event_url': button.getAttribute('href')
			});
		});
	});



	document.querySelectorAll('.button--filtri').forEach(button => {
		button.addEventListener('click', function(element) {
			const idCat = element.target.getAttribute("data-id")
			if (idCat) {

				tracking({
					'event': 'category_click',
					'event_name': 'click',
					'event_category': button.innerText
				});

				scrollToTop()
				gsap.to('div#hider', {
					opacity: 0,
					pointerEvents: 'none',
					ease: "easeIn",
				});
				document.getElementById('change-filters').innerHTML = element.target.innerHTML
				document.getElementById('filtro-selezionato').classList.remove('hidden')
				document.querySelector('html').classList.remove('show-filters')
				productList.forEach(product => {
					if (product.getAttribute('data-cat') == idCat || product.getAttribute('data-cat').includes("|" + idCat + "|")) {
						product.classList.remove('hidden')
					} else {
						product.classList.add('hidden')
					}
				});
			}
		});
	});

	//CERCA
	document.getElementById('cerca').addEventListener('click', function() {
		document.querySelector('html').classList.toggle('show-cerca')
		gsap.to('div#hider', {
			opacity: 1,
			pointerEvents: 'all',
			ease: "easeIn",
		});
		document.querySelector('html').classList.remove('show-locator')
		gsap.to('#locator', {
			y: '100%',
			duration: 0.1,
			ease: "easeIn",
		});
		document.querySelector('html').classList.remove('show-panel')
		gsap.to('#scheda', {
			y: '100%',
			duration: 0.1,
			ease: "easeIn",
		});

	});
	document.getElementById('close-filtri').addEventListener('click', function() {
		document.querySelector('html').classList.remove('show-filters')
		gsap.to('div#hider', {
			opacity: 0,
			pointerEvents: 'none',
			ease: "easeIn",
		});
	});
	document.getElementById('close-cerca').addEventListener('click', function() {
		document.querySelector('html').classList.remove('show-cerca')
		gsap.to('div#hider', {
			opacity: 0,
			pointerEvents: 'none',
			ease: "easeIn",
		});
	});

	const ricercaForm = document.getElementById('ricerca-form');
	if (ricercaForm) {
		ricercaForm.addEventListener('submit', function(event) {
			event.preventDefault();
			var ricerca = document.getElementById('testo-ricerca').value;
			scrollToTop()
			gsap.to('div#hider', {
				opacity: 0,
				pointerEvents: 'none',
				ease: "easeIn",
			});
			document.getElementById('change-filters').innerHTML = ricerca
			document.getElementById('filtro-selezionato').classList.remove('hidden')
			document.querySelector('html').classList.remove('show-cerca')

			var found = false;
			buttonFilters.forEach(product => {
				if (product.innerHTML.toLowerCase().indexOf(ricerca.toLowerCase()) !== -1 && !found) {
					product.click();
					found = true;
				}
			});
			if (!found) {
				productList.forEach(product => {
					if (product.innerHTML.toLowerCase().indexOf(ricerca.toLowerCase()) !== -1 || product.getAttribute('data-alias').toLowerCase().indexOf(ricerca.toLowerCase()) !== -1) {
						product.classList.remove('hidden')
					} else {
						product.classList.add('hidden')
					}
				});
			}
		});
	}


	//ACCORDION
	document.querySelectorAll('.title-accordion').forEach(element => {
		element.addEventListener('click', async function() {
			var accordion = this.parentNode
			var isOpen = accordion.classList.contains('open')
			accordion.classList.toggle('open')
			var innerAccordion = accordion.querySelector('.inner-accordion')
			gsap.to(innerAccordion, {
				height: isOpen ? '0' : 'auto',
				duration: 1,
			})
		});
	});


	//APRI SCHEDA
	document.querySelectorAll('.prodotto,.prodotto-slider').forEach(element => {
		element.addEventListener('click', async function(e) {
			if (e.target.classList.contains('lsp') || e.target.tagName.toLowerCase() === 'path' || e.target.tagName.toLowerCase() === 'svg') {
				let idProdotto = this.getAttribute('data-id')
				if (this.classList.contains('wished')) {
					removeFromWishlist(idProdotto)
					this.classList.remove('wished')
					if (document.querySelector('body').classList.contains('is-wishlist')) {
						document.querySelector('.prodotto[data-id="' + idProdotto + '"]').classList.add('hidden')
					}
				} else {
					tracking({
						'event': 'add_to_wishlist',
						'currency': 'EUR',
						'value': parseFloat(this.querySelector('.prezzo-prodotto').innerText.replace(/,/g, '.')),
						'items': [{
							"item_id": this.getAttribute('data-id'),
							"item_name": this.querySelector('.prodotto-title').innerText,
							"price": parseFloat(this.querySelector('.prezzo-prodotto').innerText.replace(/,/g, '.'))
						}],
					});
					addToWishlist(idProdotto)
					this.classList.add('wished')
					if (document.querySelector('body').classList.contains('is-wishlist')) {
						document.querySelector('.prodotto[data-id="' + idProdotto + '"]').classList.remove('hidden')
					}
				}
				return; // Do nothing if clicked on the "lsp" div
			}
			var data = {
				id: this.getAttribute('data-id'),
				iswishlist: document.querySelector('body').classList.contains('is-wishlist')
			}
			wishList.setAttribute('data-id', data.id)
			wishList.setAttribute('data-price', parseFloat(this.querySelector('.prezzo-prodotto').innerText.replace(/,/g, '.')))
			wishList.setAttribute('data-name', this.querySelector('.prodotto-title').innerText)

			if (isIdInWishlist(data.id)) {
				wishList.classList.add('inWishList')
			} else {
				wishList.classList.remove('inWishList')
			}


			tracking({
				'event': 'product_click',
				'event_name': 'click',
				'event_category': 'product',
				'event_label' : this.querySelector('.prodotto-title').innerText
			});

			var html = await fetch_result('get_prodotto', data)
			document.querySelector('.scoller').innerHTML = html
			setTimeout(function() {
				var prodslider = document.querySelectorAll('.prod-slider')
				if (prodslider.length > 1) {
					var elem = document.querySelector('.carousel-prod');
					var flkty = new Flickity(elem, {
						pageDots: false,
						wrapAround: true,
						adaptiveHeight: true
					});
				}
			}, 10);
			document.querySelector('html').classList.add('show-panel')
			gsap.to('#scheda', {
				y: '0%',
				duration: 0.7,
				ease: "easeIn",
			})
			document.querySelector('html').style.overflow = 'hidden'

		});
	});
	document.getElementById('chiudi-scheda').addEventListener('click', function() {
		document.querySelector('html').classList.remove('show-panel')
		gsap.to('#scheda', {
			y: '100%',
			duration: 0.7,
			ease: "easeIn",
		});
		document.querySelector('html').style.overflow = 'initial'
	});


	//APRI LOCATOR
	const cambiaSuper = document.getElementById('cambia-supermercato')
	if (cambiaSuper) {
		document.getElementById('cambia-supermercato').addEventListener('click', function() {
			document.querySelector('html').classList.add('show-locator')
			gsap.to('#locator', {
				y: '0%',
				duration: 0.7,
				ease: "easeIn",
			});
			document.querySelector('html').style.overflow = 'hidden'
		});
		document.getElementById('chiudi-locator').addEventListener('click', function() {
			document.querySelector('html').classList.remove('show-locator')
			gsap.to('#locator', {
				y: '100%',
				duration: 0.7,
				ease: "easeIn",
			});
			document.querySelector('html').style.overflow = 'initial'
		});
	}


	const queryString = window.location.search;
	const queryParams = parseQueryParams(queryString);
	if (queryParams.hasOwnProperty("negozio") || checkCookie('negozio')) {
		const negozioValue = queryParams["negozio"];
		document.querySelector('#loading').classList.add('hidden');
	} else {
		//LOCATOR
		if ('permissions' in navigator) {
			navigator.permissions.query({
				name: 'geolocation'
			}).then(function(result) {
				console.log(result.state);
				if (result.state === 'granted') {
					console.log("Geolocation permission has already been granted.");
					document.querySelector('html').classList.add('loading-position');

				} else if (result.state === 'prompt') {
					console.log("Geolocation permission is being requested.");
					result.onchange = function() {
						if (result.state === 'granted') {
							console.log("Geolocation permission has been granted.");
							document.querySelector('html').classList.add('loading-position');
						} else if (result.state === 'denied') {
							console.log("Geolocation permission has been denied.");
							document.querySelector('#loading').classList.add('hidden');
						}
					};
				} else if (result.state === 'denied') {
					document.getElementById('locator-no-location').classList.remove("hidden");
					console.log("Geolocation permission has been denied.");
					document.querySelector('#loading').classList.add('hidden');
					result.onchange = function() {
						if (result.state === 'granted') {
							console.log("Geolocation permission has been granted.");
							document.querySelector('html').classList.add('loading-position');
							document.querySelector('#loading').classList.remove('hidden');
							navigator.geolocation.getCurrentPosition(showPosition, error);
						} else if (result.state === 'denied') {
							console.log("Geolocation permission has been denied.");
							document.querySelector('#loading').classList.add('hidden');
						}
					};
				}
			});
		} else {
			console.log("The browser doesn't support the permissions API.");
			document.querySelector('#loading').classList.add('hidden');
			document.getElementById('locator-no-location').classList.remove("hidden");
		}


		if (navigator.geolocation) {
			console.log("SI GEO !");
			navigator.geolocation.getCurrentPosition(showPosition, error);
		} else {
			console.log("Geolocation is not supported by this browser.");
			document.getElementById('locator-no-location').classList.remove("hidden");
			document.querySelector('#loading').classList.add('hidden');
		}
	}

	function error(err) {
		console.warn(`ERROR(${err.code}): ${err.message}`);
		document.getElementById('locator-no-location').classList.remove("hidden");
		document.querySelector('#loading').classList.add('hidden');
	}


	async function showPosition(position) {
		console.log("ENTERED");
		document.querySelector('html').classList.add('loading-position');


		var lat = position.coords.latitude;
		var lng = position.coords.longitude;

		var data = {
			lat,
			lng
		}
		var negozio = await fetch_result('get_negozio', data)
		//const days = [
		//	'sunday',
		//	'monday',
		//	'tuesday',
		//	'wednesday',
		//	'thursday',
		//	'friday',
		//	'saturday',
		//];
		//const openingHours = JSON.parse(negozio.open_hours);
		//const currentDayOfWeek = new Date().getDay();
		//const currentTime = new Date().toLocaleTimeString('en-US', {
		//	hour12: false,
		//	hour: '2-digit',
		//	minute: '2-digit'
		//});
		//if (openingHours.hasOwnProperty(days[currentDayOfWeek])) {
		//	const dayOpeningHours = openingHours[days[currentDayOfWeek]];
		//	for (const hours of dayOpeningHours) {
		//		const [start, end] = hours.split('-');
		//		if (currentTime >= start && currentTime <= end) {
		//			document.querySelector('.se-aperto').innerHTML = "Aperto ora";
		//			break;
		//		}
		//	}
		//} else {
		//	document.querySelector('.se-aperto').innerHTML = "Chiuso";
		//	document.querySelector('.se-aperto').classList.remove('text-green');
		//	document.querySelector('.se-aperto').classList.add('text-red')
		//}
		//document.querySelector('.nome-localita').innerHTML = negozio.city + "(" + negozio.district + ")";
		await setCookie("negozio", negozio.codice, 1);
		await setCookie("scelto", false, 1);
		await setCookie("lat", position.coords.latitude, 1);
		await setCookie("lng", position.coords.longitude, 1);
		location.reload();
		console.log(negozio);
	}


	//WISHLIST
	function isIdInWishlist(id) {
		var wishlist = getWishlist();
		return (wishlist) ? wishlist.includes(id) : false;
	}

	function addToWishlist(id) {
		var wishlist = getWishlist();
		// Check if the ID is already in the wishlist
		if (!wishlist.includes(id)) {
			wishlist.push(id);
			updateWishlistCookie(wishlist);
		}
	}

	function removeFromWishlist(id) {
		var wishlist = getWishlist();

		// Check if the ID is in the wishlist
		var index = wishlist.indexOf(id);
		if (index !== -1) {
			wishlist.splice(index, 1);
			updateWishlistCookie(wishlist);
		}
	}

	function getWishlist() {
		var wishlistCookie = getCookie("wishlist");
		console.log(wishlistCookie);
		return (wishlistCookie && wishlistCookie != "null") ? JSON.parse(wishlistCookie) : [];
	}

	function updateWishlistCookie(wishlist) {
		console.log(JSON.stringify(wishlist));
		setCookie("wishlist", JSON.stringify(wishlist), 100);
	}

	//function setCookie(name, value, days) {
	//	var expires = "";
	//	if (days) {
	//		var date = new Date();
	//		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	//		expires = "; expires=" + date.toUTCString();
	//	}
	//	document.cookie = name + "=" + value + expires + "; path=/";
	//}

	function getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	const shareemlista = document.querySelector('#share-em-lista')
	if (shareemlista) {
		shareemlista.addEventListener('click', function() {
			tracking({
				'event': 'share',
				'method': 'Email',
				'content_type': 'whishlist'
			});
		});
	}
	const sharewalista = document.querySelector('#share-wa-lista')
	if (sharewalista) {
		sharewalista.addEventListener('click', function() {
			tracking({
				'event': 'share',
				'method': 'Whatsapp',
				'content_type': 'whishlist'
			});
		});
	}

	const next = document.querySelector('button.flickity-button.flickity-prev-next-button.next')
	if(next) {
		next.addEventListener('click',function(){
			tracking({
				'event': 'carousel_move',
				'event_category': 'carousel',
				'event_label': 'right'
			});
		})
	}
	const prev = document.querySelector('button.flickity-button.flickity-prev-next-button.previous')
	if(prev) {
		prev.addEventListener('click',function(){
			tracking({
				'event': 'carousel_move',
				'event_category': 'carousel',
				'event_label': 'left'
			});
		})
	}


	let percentageCheck = {
			1: false,
			25: false,
			50: false,
			75: false,
			100: false
	}
	let percentageSend = [1 ,25, 50, 75, 100]
	window.addEventListener('scroll', function() {
		let scrollPercentage = (document.documentElement.scrollTop + document.body.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight) * 100;
		scrollPercentage = Math.round(scrollPercentage);

		if (!percentageCheck[1] && scrollPercentage >= 0.000001 && scrollPercentage < 25) {
			percentageCheck[1] = true;

			tracking({
				'event': 'page_scroll',
				'event_name': 'scroll',
				'event_category': 'scroll',
				'event_label': 'First Scroll',
				'value': 0,
			});

		}

		if (!percentageCheck[25] && scrollPercentage >= 25 && scrollPercentage < 50) {
			percentageCheck[25] = true;

			tracking({
				'event': 'page_scroll',
				'event_name': 'scroll',
				'event_category': 'scroll',
				'event_label': '25%',
				'value': 25,
			});

		}
		if (!percentageCheck[50] && scrollPercentage >= 50 && scrollPercentage < 75) {
			percentageCheck[50] = true;
			tracking({
				'event': 'page_scroll',
				'event_name': 'scroll',
				'event_category': 'scroll',
				'event_label': '50%',
				'value': 50,
			});
		}
		if (!percentageCheck[75] && scrollPercentage >= 75 && scrollPercentage < 100) {
			percentageCheck[75] = true;
			tracking({
				'event': 'page_scroll',
				'event_name': 'scroll',
				'event_category': 'scroll',
				'event_label': '75%',
				'value': 75,
			});
		}
		if (!percentageCheck[100] && scrollPercentage == 100) {
			percentageCheck[100] = true;
			tracking({
				'event': 'page_scroll',
				'event_name': 'scroll',
				'event_category': 'scroll',
				'event_label': '100%',
				'value': 100,
			});
		}
	});

	wishList.addEventListener('click', async function() {
		let idProdotto = wishList.getAttribute('data-id')
		if (!isIdInWishlist(idProdotto)) {

			tracking({
				'event': 'add_to_wishlist',
				'currency': 'EUR',
				'value': parseFloat(this.getAttribute('data-price').replace(/,/g, '.')),
				'items': [{
					"item_id": idProdotto,
					"item_name": this.getAttribute('data-name'),
					"price": parseFloat(this.getAttribute('data-price').replace(/,/g, '.'))
				}],
			});

			addToWishlist(idProdotto)
			wishList.classList.add('inWishList')

			if (document.querySelector('.prodotto[data-id="' + idProdotto + '"]')) {
				document.querySelector('.prodotto[data-id="' + idProdotto + '"]').classList.add('wished')
			}
			if (document.querySelector('.prodotto-slider[data-id="' + idProdotto + '"]')) {
				document.querySelector('.prodotto-slider[data-id="' + idProdotto + '"]').classList.add('wished')
			}

			if (document.querySelector('body').classList.contains('is-wishlist')) {
				document.querySelector('.prodotto[data-id="' + idProdotto + '"]').classList.remove('hidden')
			}
		} else {
			removeFromWishlist(idProdotto)
			wishList.classList.remove('inWishList')

			if (document.querySelector('.prodotto[data-id="' + idProdotto + '"]')) {
				document.querySelector('.prodotto[data-id="' + idProdotto + '"]').classList.remove('wished')
			}
			if (document.querySelector('.prodotto-slider[data-id="' + idProdotto + '"]')) {
				document.querySelector('.prodotto-slider[data-id="' + idProdotto + '"]').classList.remove('wished')
			}

			if (document.querySelector('body').classList.contains('is-wishlist')) {
				document.querySelector('.prodotto[data-id="' + idProdotto + '"]').classList.add('hidden')
			}
		}

	})


	//SHARE
	function getParameterByName(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}

	var prodottoValue = getParameterByName('prodotto');
	if (prodottoValue !== null) {
		getProdotto(prodottoValue)
	}
	async function getProdotto(idProdotto) {
		var data = {
			id: idProdotto,
			iswishlist: document.querySelector('body').classList.contains('is-wishlist')
		}
		wishList.setAttribute('data-id', data.id)
		if (isIdInWishlist(data.id)) {
			wishList.classList.add('inWishList')
		} else {
			wishList.classList.remove('inWishList')
		}
		var html = await fetch_result('get_prodotto', data)
		document.querySelector('.scoller').innerHTML = html
		setTimeout(function() {
			var prodslider = document.querySelectorAll('.prod-slider')
			if (prodslider.length > 1) {
				var elem = document.querySelector('.carousel-prod');
				var flkty = new Flickity(elem, {
					pageDots: false,
					wrapAround: true,
					adaptiveHeight: true
				});
			}
		}, 10);
		document.querySelector('html').classList.add('show-panel')
		gsap.to('#scheda', {
			y: '0%',
			duration: 0.7,
			ease: "easeIn",
		})
		document.querySelector('html').style.overflow = 'hidden'
	}

	var svuotaLista = document.querySelector('#svuota-lista')
	if (svuotaLista) {
		svuotaLista.addEventListener('click', async function() {
			setCookie('wishlist', '', 365)
			document.querySelector('#wishlist-container-tot').innerHTML = `<div class="text-14 leading-14 text-center">La tua lista della spesa è vuota</div>`;
		});
	}

	var urlLista = new URL(window.location.href);
	var listaValue = urlLista.searchParams.get("lista");
	if (listaValue) {
		var decodedLista = JSON.parse(decodeURIComponent(listaValue.replace(/\+/g, ' ')));
		setCookie('wishlist', decodedLista, 100)
	}



}